// extracted by mini-css-extract-plugin
module.exports = {"note-icon":"AnnotationLineIcon__note-icon___Aj5L7","selected":"AnnotationLineIcon__selected___wHcFh"};